<template>
  <standart-template>
    <div class="filters-container mb-3 bg-greyLight rounded-md overflow-hidden">
      <div
        class="flex items-center justify-between p-3 cursor-pointer"
        @click="filtersExpanded = !filtersExpanded"
      >
        <div class="text-sm font-semibold">Фильтры</div>
        <div class="flex items-center">
          <svg
            :class="{ 'rotate-180': filtersExpanded }"
            class="w-4 h-4 transition-transform"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </div>

      <div v-show="filtersExpanded" class="p-3 pt-0 overflow-hidden">
        <div class="grid grid-cols-1 gap-3">
          <div class="min-w-0">
            <label class="text-xs text-gray-600">Дата от</label>
            <input
              type="date"
              v-model="filtersDatetimeFrom"
              class="w-full p-2 text-sm border rounded mt-1 min-w-0 box-border appearance-none"
              @change="applyFilters"
            />
          </div>
          <div class="min-w-0">
            <label class="text-xs text-gray-600">Дата до</label>
            <input
              type="date"
              v-model="filtersDatetimeTo"
              class="w-full p-2 text-sm border rounded mt-1 min-w-0 box-border appearance-none"
              @change="applyFilters"
            />
          </div>
          <div>
            <label class="text-xs text-gray-600">Номер карты</label>
            <input
              type="text"
              v-model="filters.card_suffix"
              maxlength="4"
              placeholder="Последние 4 цифры"
              class="w-full p-2 text-sm border rounded mt-1"
              @change="applyFilters"
            />
          </div>
          <div>
            <label class="text-xs text-gray-600">Статус</label>
            <select
              v-model="filters.status"
              class="w-full p-2 text-sm border rounded mt-1"
              @change="applyFilters"
            >
              <option :value="null">Все статусы</option>
              <option value="PAID">Успешно</option>
              <option value="IN_PROCESSING">В обработке</option>
              <option value="ERROR">Ошибка</option>
              <option value="REVERTED">Возвращено</option>
            </select>
          </div>
        </div>
        <button
          v-if="hasActiveFilters"
          @click="resetFilters"
          class="mt-3 w-full py-2 text-sm bg-blue text-white rounded-lg"
        >
          Сбросить фильтры
        </button>
      </div>
    </div>

    <button
      v-if="!isAtTop"
      @click="scrollToTop"
      class="fixed bottom-24 right-4 w-12 h-12 rounded-full bg-blue text-white flex items-center justify-center shadow-lg z-50"
    >
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 15l7-7 7 7"
        />
      </svg>
    </button>
    <PullRefresh
      v-model="reloadLoading"
      @refresh="onRefresh"
      loading-text="Обновляем информацию"
      loosing-text="Отпустите для обновления"
      pulling-text="Потяните для обновления"
      success-text="Успешно обновлено"
      success-duration="1500"
    >
      <div
        v-if="isLoadData && notifications.length > 0"
        data-cy="notificationList"
        class="mt-1"
      >
        <div
          v-for="(item, index) in notifications"
          :key="index"
          class="relative mb-3 rounded-md bg-greyLight p-4"
        >
          <div class="flex items-start justify-between">
            <div class="w-[60%]">
              <div class="text-lg overflow-x-auto">
                {{ item.card_name }}
              </div>
              <div class="text-sm">
                <div>Списано: {{ item.amount }}</div>
                <div v-if="item.commission_withheld">
                  Отправлено:
                  {{ mathCommission(item.amount, item.commission_withheld) }}
                </div>
                <div v-if="item.commission_withheld">
                  Комиссия: {{ item.commission_withheld }}
                </div>
                <div v-if="item.partner_bank_name">
                  {{ `${item.partner_bank_name}` }}
                </div>
              </div>
            </div>
            <div class="flex flex-col items-center">
              <div
                :class="
                  validateTransactionStatus(
                    item.status,
                    item.adapter_status,
                    'color',
                  )
                "
                class="flex w-full justify-center rounded-md py-1 px-2 text-sm text-white"
              >
                {{
                  validateTransactionStatus(
                    item.status,
                    item.adapter_status,
                    "text",
                  )
                }}
              </div>

              <div
                v-if="
                  (item.date_time && isActiveContactParent(item.date_time)) ||
                  item.status != 'IN_PROCESSING'
                "
                @click="validateNotComingMoney(item)"
                class="cursor-pointer mt-3 flex w-full items-center justify-center rounded-full bg-background py-1 px-2 text-sm text-blue"
              >
                <div
                  v-if="
                    item.status === 'PAID' ||
                    item.status === 'IN_PROCESSING' ||
                    item.status === 'ALLOW_TRANSACTION'
                  "
                >
                  Не получил
                </div>
                <div
                  v-if="
                    (item.status === 'ERROR' &&
                      (item.adapter_status === 'SUCCESS' ||
                        item.adapter_status === 'NULL' ||
                        item.adapter_status === 'FAILED')) ||
                    item.status === 'BLOCK_TRANSACTION' ||
                    (item.status === 'ERROR' &&
                      item.adapter_status !== 'REVERTED')
                  "
                >
                  Почему?
                </div>
                <div
                  v-if="
                    item.status === 'ERROR' &&
                    item.adapter_status === 'REVERTED'
                  "
                >
                  Не вернулось
                </div>
              </div>
            </div>
          </div>
          <div class="text-sm mt-1">{{ item.card_number }}</div>

          <div class="absolute bottom-1 right-4 text-xs">
            {{ formatDate(item.date_time) }}
          </div>
        </div>
      </div>
    </PullRefresh>

    <div class="text-center text-xl" v-if="isLoadData && count <= 0">
      У вас еще нет уведомлений, но они обязательно появятся
    </div>

<confirm-modal
      v-if="shouldShowSupportButtons() && showMaxSupport"
      :state="helpDialogModal"
      :decline-button-text="validateDeclineBtnText()"
      :htmlDescription="`${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          } ${
              this.currentNotification?.status === 'ERROR' &&
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Но на карту не зачислены, разбираемся с проблемой.'
                : ''
            }  ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы обратитесь в поддержку.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК.`
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, выберите способ связи.'
          : ''
      }
       ${
          this.currentNotification?.status === 'IN_PROCESSING'
            ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.'
            : ''
        }  `"
      @decline="validateDeclineBtn()"
      @confirm="handleMaxSupportRequest()"
      @confirmSecondary="handleTelegramSupportRequest()"
    >
      <template v-slot:confirm-title>
        <div class="flex items-center">
          <div>Написать в MAX</div>
          <div class="ml-2 text-2xl">
            <img src="@/assets/img/general/max-black.svg" class="w-5 h-5" />
          </div>
        </div>
      </template>
      <template v-slot:confirm-secondary-title>
        <div class="flex items-center">
          <div>Написать в Telegram</div>
          <div class="ml-2 text-2xl">
            <i class="fab fa-telegram-plane" />
          </div>
        </div>
      </template>
    </confirm-modal>
    <confirm-modal
      v-else-if="shouldShowSupportButtons()"
      :state="helpDialogModal"
      :decline-button-text="validateDeclineBtnText()"
      :htmlDescription="`${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          } ${
              this.currentNotification?.status === 'ERROR' &&
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Но на карту не зачислены, разбираемся с проблемой.'
                : ''
            }  ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы обратитесь в поддержку.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК.`
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, выберите способ связи.'
          : ''
      }
       ${
          this.currentNotification?.status === 'IN_PROCESSING'
            ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.'
            : ''
        }  `"
      @decline="validateDeclineBtn()"
      @confirm="handleTelegramSupportRequest()"
    >
      <template v-slot:confirm-title>
        <div class="flex items-center">
          <div>Написать в Telegram</div>
          <div class="ml-2 text-2xl">
            <i class="fab fa-telegram-plane" />
          </div>
        </div>
      </template>
    </confirm-modal>

    <confirm-modal
      v-else
      :state="helpDialogModal"
      :confirm-button-text="validateConfirmBtnText()"
      :decline-button-text="validateDeclineBtnText()"
      :htmlDescription="`${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          } ${
              this.currentNotification?.status === 'ERROR' &&
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Но на карту не зачислены, разбираемся с проблемой.'
                : ''
            }   ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы нажмите «Уточнить».\n Поддержка приложения работает с 10 до 22 по МСК.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло нажмите «Не получил» и свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК. `
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.\n Если возникли вопросы нажмите «Уточнить».'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, дадим номер операции для поиска в вашем банке.'
          : ''
      }
       ${
         this.currentNotification?.status === 'IN_PROCESSING'
           ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.\n Если возникли вопросы нажмите «Уточнить».'
           : ''
       }  `"
      @decline="validateDeclineBtn()"
      @confirm="validateConfirmBtn()"
    />

    <status-modal
      :state="statusModalDialog"
      button-text="Понял"
      :description="statusModalText"
      type="warning"
      @confirm="statusModalDialog = false"
    />

    <status-modal
      :state="supportModalDialog"
      button-text="Отмена"
      :description="'Для связи с «Парком» вы можете:'"
      type="warning"
      @confirm="supportModalDialog = false"
      @wa="sendWhatsAppPark()"
      @tm="sendTelegramPark()"
      @max="sendMaxPark()"
      @openEmail="sendEmailPark()"
      :isSupportModal="true"
      :wa-support="currentCabinetSupportLinks.wa_support"
      :tm-support="currentCabinetSupportLinks.tm_support"
      :max-support="currentCabinetSupportLinks.max_support"
      :email-support="currentCabinetSupportLinks.email_support"
    />

    <notification-page-skeleton v-if="!isLoadData" />
    <div class="flex justify-center items-center py-4">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FFD92E]"
      ></div>
    </div>
  </standart-template>
</template>

<script lang="ts">
import ApiNotifications, { ITransactionsFilters } from "@/api/ApiNotifications";
import ConfirmModal from "@/components/Modals/ConfirmModal.vue";
import StatusModal from "@/components/Modals/StatusModal.vue";
import NotificationPageSkeleton from "@/components/Skeleton/NotificationPageSkeleton.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import store from "@/store";
import { ILinkSupport } from "@/struct/ILinkSupport/ILinkSupport";
import UtilError from "@/util/ValidateError/UtilError";
import {
  ENotificationStatus,
  ENotificationStatusAdapter,
  INotification,
} from "@/struct/INotifications/INotification";
import { IUserData } from "@/struct/IStore/IStore";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import PullRefresh from "pull-refresh-vue3";
import { Action, Getter } from "s-vuex-class";
import { Options, Vue } from "vue-class-component";

dayjs.extend(duration);
dayjs.extend(utc);

@Options({
  components: {
    StatusModal,
    ConfirmModal,
    NotificationPageSkeleton,
    StandartTemplate,
    PullRefresh,
  },
})
export default class NotificationsPage extends Vue {
  @Action("getUserData") private getUserData: (() => void) | undefined;
  @Getter("getUserData") private userData: IUserData | undefined;
  @Action("getLinkSupport") private getLinkSupport: (() => void) | undefined;
  @Getter("getLinkSupport") private linkSupport: ILinkSupport[] | undefined;
  @Getter("validateUserPlatform") private platformApp: string | undefined;
  @Getter("appName") private appName: string | undefined;

  private isBrand = process.env.VUE_APP_BRAND_ID;

  private get showMaxSupport(): boolean {
    const allowedBrands = [
      "",
      "3e85e76b00b84703844d8347aff3d0b8",
      "82e8c1ebec3b4b86a16c29a550f4854e",
    ];
    return allowedBrands.includes(this.isBrand);
  }

  public waSupport!: string;
  public tmSupport!: string;
  public waPark!: string;
  public tmPark!: string;
  private tab: "notification" | "history" = "notification";
  private isLoadData = false;
  private count = 0;
  private offset = 0;
  private loadNotificationInterval: number | null = null;
  private notifications: INotification[] = [];
  private currentNotification: INotification | null = null;
  private appVersion: string | null = null;
  private scrollId: string | null = null;
  private isScrollLoading = false;
  private lastScrollLoadTime = 0;
  private isAtTop = true;
  private lastScrollPosition = 0;
  private reloadLoading = false;
  private filters: ITransactionsFilters = {
    datetime_from: null,
    datetime_to: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
    limit: null,
    card_suffix: null,
    status: null,
  };
  private filtersExpanded = false;
  private filtersDatetimeFrom = "";
  private filtersDatetimeTo = "";

  get hasActiveFilters(): boolean {
    return (
      !!this.filters.datetime_from ||
      !!this.filters.datetime_to ||
      !!this.filters.card_suffix ||
      !!this.filters.status
    );
  }

  private helpDialogModal = false;
  private disabledDialogModal = false;

  private statusModalDialog = false;
  private supportModalDialog = false;
  private statusModalText = "";

  get currentCabinetSupportLinks() {
    if (!this.linkSupport || !this.currentNotification?.cabinet_driver_id) {
      return {
        wa_support: "",
        tm_support: "",
        max_support: "",
        email_support: "",
      };
    }

    const support = this.linkSupport.find(
      (el) =>
        el?.cabinet_driver_id == this.currentNotification?.cabinet_driver_id,
    );

    return {
      wa_support: support?.wa_support || "",
      tm_support: support?.tm_support || "",
      max_support: support?.max_support || "",
      email_support: support?.email_support || "",
    };
  }

  private validateDeclineBtn() {
    if (
      this.currentNotification?.status === "ERROR" &&
      this.currentNotification?.adapter_status === "REVERTED"
    ) {
      return this.waitingForPayment();
    } else {
      this.helpDialogModal = false;
    }
  }

  private shouldShowSupportButtons(): boolean {
    if (
      this.currentNotification?.status === "ERROR" &&
      this.currentNotification?.adapter_status != "REVERTED"
    ) {
      if (
        this.currentNotification?.status_payout === "NO_TRANSACTION_DATA" ||
        this.currentNotification?.status_payout ===
          "DRIVER_GET_BALANCE_ERROR" ||
        this.currentNotification?.status_payout ===
          "ADAPTER_PROCESSING_ERROR" ||
        this.currentNotification?.status_payout ===
          "BANK_INITIALIZATION_ERROR" ||
        this.currentNotification?.status_payout ===
          "BANK_CREATE_PAYMENT_ERROR" ||
        this.currentNotification?.status_payout === "BANK_CONFIRMATION_ERROR" ||
        this.currentNotification?.status_payout === "TIMEOUT_CONFIRMATION_ERROR"
      ) {
        return true;
      }
    }

    if (
      this.currentNotification?.status === "ALLOW_TRANSACTION" ||
      this.currentNotification?.status === "PAID" ||
      this.currentNotification?.status === "IN_PROCESSING" ||
      (this.currentNotification?.status === "ERROR" &&
        this.currentNotification?.adapter_status === "REVERTED")
    ) {
      if (this.currentNotification?.status_payout !== "EXCEPTION_FRAUD") {
        return true;
      }
    }

    return false;
  }

  private validateConfirmBtn() {
    if (this.currentNotification?.status === "BLOCK_TRANSACTION") {
      this.supportModalDialog = true;
      return;
    } else if (
      this.currentNotification?.status === "ERROR" &&
      this.currentNotification?.adapter_status != "REVERTED"
    ) {
      if (
        this.currentNotification?.status_payout === "NO_TRANSACTION_DATA" ||
        this.currentNotification?.status_payout ===
          "DRIVER_GET_BALANCE_ERROR" ||
        this.currentNotification?.status_payout ===
          "ADAPTER_PROCESSING_ERROR" ||
        this.currentNotification?.status_payout ===
          "BANK_INITIALIZATION_ERROR" ||
        this.currentNotification?.status_payout ===
          "BANK_CREATE_PAYMENT_ERROR" ||
        this.currentNotification?.status_payout === "BANK_CONFIRMATION_ERROR" ||
        this.currentNotification?.status_payout === "TIMEOUT_CONFIRMATION_ERROR"
      ) {
        return this.handleTelegramSupportRequest();
      } else {
        this.supportModalDialog = true;
        return;
      }
    } else if (
      this.currentNotification?.status === "ALLOW_TRANSACTION" ||
      this.currentNotification?.status === "PAID" ||
      this.currentNotification?.status === "IN_PROCESSING" ||
      (this.currentNotification?.status === "ERROR" &&
        this.currentNotification?.adapter_status === "REVERTED")
    ) {
      if (this.currentNotification?.status_payout === "EXCEPTION_FRAUD") {
        console.log("fraud");
        return (this.supportModalDialog = true);
      } else {
        return this.handleTelegramSupportRequest();
      }
    } else {
      this.helpDialogModal = false;
    }
  }
  private validateConfirmBtnText() {
    if (
      this.currentNotification?.status === "ALLOW_TRANSACTION" ||
      (this.currentNotification?.status === "ERROR" &&
        this.currentNotification?.adapter_status === "REVERTED") ||
      this.currentNotification?.status === "PAID"
    ) {
      return "Не получил";
    } else if (
      this.currentNotification?.status === "BLOCK_TRANSACTION" ||
      this.currentNotification?.status === "ERROR" ||
      this.currentNotification?.status === "IN_PROCESSING"
    ) {
      return this.currentNotification?.status_payout ===
        "SCORE_NOT_ENOUGH_MONEY"
        ? "Сообщить в парк"
        : "Уточнить";
    } else {
      return "Понял";
    }
  }
  private validateDeclineBtnText() {
    if (
      this.currentNotification?.status === "ERROR" &&
      this.currentNotification?.adapter_status === "REVERTED"
    ) {
      return "Проверить";
    } else if (
      this.currentNotification?.status === "BLOCK_TRANSACTION" ||
      this.currentNotification?.status === "IN_PROCESSING"
    ) {
      return "Подождать";
    } else {
      return "Понял";
    }
  }
  private async onRefresh() {
    this.reloadLoading = true;
    await this.loadData();
    this.reloadLoading = false;
  }

  private async loadData(isScrollLoad = false) {
    if (this.isScrollLoading) {
      return;
    }

    if (isScrollLoad && (!this.scrollId || this.isScrollLoading)) {
      return;
    }

    if (isScrollLoad) {
      this.isScrollLoading = true;
    }

    const response = isScrollLoad
      ? await ApiNotifications.getTransactionsScroll(this.scrollId!)
      : await ApiNotifications.getTransactions(this.filters);

    // Тело ошибки бека: на ручной загрузке — модалка с message,
    // на догрузке при скролле — тихо (не спамим), список сохраняем.
    if (UtilError.isBackendErrorBody(response)) {
      if (!isScrollLoad) {
        UtilError.showBackendErrorBody(response);
        this.isLoadData = true;
      }
    } else if (typeof response != "boolean") {
      if (response && response?.results?.length > 0) {
        this.count = response.count;
        this.scrollId = response.scroll_id || null;

        let results = response.results;

        if (this.filters.status === "ERROR") {
          results = results.filter(
            (item: INotification) => item.status !== "ALLOW_TRANSACTION",
          );
        }

        if (isScrollLoad) {
          this.notifications = [...this.notifications, ...results];
        } else {
          this.notifications = results;
        }
      } else if (!isScrollLoad) {
        this.notifications = [];
        this.scrollId = null;
      }
      this.isLoadData = true;
    }

    if (isScrollLoad) {
      this.isScrollLoading = false;
    }
  }

  private applyFilters() {
    let status: string | null = null;
    let status_adapter: string | null = null;

    const selectedStatus = this.filters.status;
    if (selectedStatus) {
      switch (selectedStatus) {
        case "PAID":
          status = "PAID";
          break;
        case "IN_PROCESSING":
          status = "IN_PROCESSING";
          break;
        case "ERROR":
          status = "ERROR";
          break;
        case "REVERTED":
          status_adapter = "REVERTED";
          status = "REVERTED";
          break;
        case "BLOCK_TRANSACTION":
          status = "BLOCK_TRANSACTION";
          break;
        default:
          status = selectedStatus;
      }
    }

    const formattedFilters: ITransactionsFilters = {
      datetime_from: this.filtersDatetimeFrom
        ? dayjs(this.filtersDatetimeFrom)
            .startOf("day")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss[Z]")
        : null,
      datetime_to: this.filtersDatetimeTo
        ? dayjs(this.filtersDatetimeTo)
            .endOf("day")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss[Z]")
        : null,
      limit: this.filters.limit,
      card_suffix: this.filters.card_suffix || null,
      status,
      status_adapter,
    };

    this.filters = formattedFilters;
    this.scrollId = null;
    this.loadData();
  }

  private resetFilters() {
    this.filtersDatetimeFrom = "";
    this.filtersDatetimeTo = "";
    this.filters = {
      datetime_from: null,
      datetime_to: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
      limit: null,
      card_suffix: null,
      status: null,
      status_adapter: null,
    };
    this.scrollId = null;
    this.loadData();
  }

  private handleScroll() {
    const scrollPosition = window.scrollY;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const now = Date.now();

    const isScrollingDown = scrollPosition > this.lastScrollPosition;
    this.lastScrollPosition = scrollPosition;

    if (scrollPosition <= 100 && !this.isAtTop) {
      this.isAtTop = true;
      if (!this.isScrollLoading) {
        this.loadData();
      }
    } else if (scrollPosition > 100 && this.isAtTop) {
      this.isAtTop = false;
    }

    if (
      isScrollingDown &&
      scrollPosition + windowHeight >= documentHeight - 100 &&
      this.scrollId &&
      !this.isScrollLoading &&
      now - this.lastScrollLoadTime >= 500
    ) {
      this.lastScrollLoadTime = now;
      this.loadData(true);
    }
  }

  private scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.isAtTop = true;
  }

  private formatDate(date: string) {
    return dayjs.utc(date).local().format("HH:mm DD.MM.YYYY");
  }

  private validateTransactionStatus(
    status: ENotificationStatus,
    adapter_status: ENotificationStatusAdapter,
    type: "color" | "text",
  ) {
    if (adapter_status === ENotificationStatusAdapter.Reverted) {
      return type === "color" ? "bg-blue" : "Возвращено";
    }

    if (status === ENotificationStatus.Paid) {
      return type === "color" ? "bg-green" : "Успешно";
    }

    if (status === ENotificationStatus.Process) {
      return type === "color" ? "bg-primary" : "Выполняется";
    }

    if (status === ENotificationStatus.Error) {
      return type === "color" ? "bg-red" : "Ошибка";
    }

    if (status === ENotificationStatus.BlockTransaction) {
      return type === "color" ? "bg-[#969DB5]" : "На проверке";
    }

    if (status === ENotificationStatus.AllowTransaction) {
      return type === "color" ? "bg-green" : "Успешно";
    }
  }

  private isActiveContactParent(dateString: string) {
    const date = dayjs(dateString);
    const now = dayjs();
    // Вычисляем разницу между датами
    const difference = now.diff(date);
    // Создаем длительность разницы в минутах
    const differenceInMinutes = dayjs.duration(difference).asMinutes();
    // Проверяем, прошло ли 15 минут
    return differenceInMinutes >= 15;
  }

  private validateNotComingMoney(notification: INotification) {
    if (!this.userData) this.getUserData?.();
    this.currentNotification = notification;
    this.helpDialogModal = true;
  }

  private async waitingForPayment() {
    this.helpDialogModal = false;
    this.$router.push("/home");
  }

  private async handleMaxSupportRequest() {
    this.helpDialogModal = false;
    Browser.open({
      url: `${process.env.VUE_APP_MAX_SUPPORT_BOT_URL}`,
    });
  }

  private async handleTelegramSupportRequest() {
    const date = dayjs(this.currentNotification?.date_time).format(
      "DD-MM-YYYY HH:mm:ss",
    );

    let message = `Проблема с переводом.`;
    if (this.userData?.full_name) message += ` ${this.userData.full_name}.`;
    if (this.userData?.phone_number)
      message += ` ${this.userData.phone_number}.`;
    if (this.currentNotification?.amount)
      message += ` Сумма: ${this.currentNotification.amount},`;
    if (this.currentNotification?.card_number)
      message += ` Номер карты: ${this.currentNotification.card_number},`;
    message += ` Дата: ${date},`;
    message += ` Статус: ${this.validateTransactionStatus(
      this.currentNotification?.status as ENotificationStatus,
      this.currentNotification?.adapter_status as ENotificationStatusAdapter,
      "text",
    )}`;

    if (this.currentNotification?.status_description) {
      message += `, ${this.currentNotification.status_description}`;
    }

    if (this.currentNotification?.status_payout) {
      message += `, Причина: ${this.currentNotification.status_payout}.`;
    }

    message += `\nТип приложения: ${this.$APP_TYPE}`;
    message += `\nПлатформа: ${this.$PLATFORM}`;
    if (this.appVersion) {
      message += `\nВерсия приложения: ${this.appVersion}`;
    }
    if (store.state.appName && this.isBrand.length)
      message += `\nБренд: ${store.state.appName}`;

    this.helpDialogModal = false;

    const baseRedirectUrl = process.env.VUE_APP_TELEGRAM_SUPPORT_BOT_URL;
    let finalUrl = baseRedirectUrl;

    try {
      const response = await fetch("https://brand.force2.cc/api/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.code) {
          const userId = false;
          // const userId = this.userData?.id; включить для добавления uuid в url для TG
          if (userId) {
            finalUrl = `${baseRedirectUrl}?start=${encodeURIComponent(
              `uuid=${userId}&tmp=${data.code}`,
            )}`;
          } else {
            finalUrl = `${baseRedirectUrl}?start=${encodeURIComponent(
              `tmp=${data.code}`,
            )}`;
          }
        }
      } else {
        console.error("Support API error:", await response.text());
      }
    } catch (error) {
      console.warn("Support fetch failed, using base URL:", error);
    }
    await this.openUrlInNewTab(finalUrl);
  }

  private async openUrlInNewTab(url: string): Promise<void> {
    if (this.$PLATFORM !== "web" && typeof Browser !== "undefined") {
      try {
        await Browser.open({
          url: url,
          windowName: "_blank",
        });
        return;
      } catch (error) {
        console.warn("Browser.open failed, falling back:", error);
      }
    }

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.style.display = "none";
    link.setAttribute("aria-hidden", "true");

    document.body.appendChild(link);

    try {
      link.click();
    } catch (e) {
      window.open(url, "_blank", "noopener,noreferrer");
    }

    setTimeout(() => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    }, 100);
  }

  private async sendTelegramPark() {
    if (this.linkSupport) {
      this.linkSupport.forEach((el) => {
        if (
          el?.cabinet_driver_id == this.currentNotification?.cabinet_driver_id
        ) {
          this.tmPark = el.tm_support;
        }
      });
    }
    let tmLink = this.tmPark;

    Browser.open({
      url: `${tmLink}`,
    });
    this.helpDialogModal = false;
  }

  private async sendWhatsAppPark() {
    if (this.linkSupport) {
      this.linkSupport.forEach((el) => {
        if (
          el?.cabinet_driver_id == this.currentNotification?.cabinet_driver_id
        ) {
          this.waPark = el.wa_support;
        }
      });
    }
    let phoneNumber = this.waPark;

    const date = dayjs(this.currentNotification?.date_time).format(
      "DD-MM-YYYY HH:mm:ss",
    );

    let message;
    if (this.currentNotification?.status_payout === "SCORE_NOT_ENOUGH_MONEY") {
      message = encodeURI(
        `Проблема с переводом. ${this.userData?.full_name}. ${
          this.userData?.phone_number
        }. Сумма: ${this.currentNotification?.amount}, Номер карты: ${
          this.currentNotification?.card_number
        }, Дата: ${date}, Статус: ${this.validateTransactionStatus(
          this.currentNotification?.status as ENotificationStatus,
          this.currentNotification
            ?.adapter_status as ENotificationStatusAdapter,
          "text",
        )}, Причина: На счёте партнёра («Парка») было недостаточно средств.`,
      );
    } else {
      message = encodeURI(
        `Проблема с переводом. ${this.userData?.full_name}. ${
          this.userData?.phone_number
        }. Сумма: ${this.currentNotification?.amount}, Номер карты: ${
          this.currentNotification?.card_number
        }, Дата: ${date}, Статус: ${this.validateTransactionStatus(
          this.currentNotification?.status as ENotificationStatus,
          this.currentNotification
            ?.adapter_status as ENotificationStatusAdapter,
          "text",
        )}${
          this.currentNotification?.status_description
            ? `, ${this.currentNotification.status_description}`
            : ""
        }${
          this.currentNotification?.status_payout
            ? `, Причина:  ${this.currentNotification.status_payout}.`
            : ""
        }`,
      );
    }

    // console.log(this.waPark ? this.waPark : "номер не получен");
    Browser.open({
      url: `https://wa.me/${phoneNumber}?text=${message}`,
    });
    this.helpDialogModal = false;
  }

  private async sendMaxPark() {
    if (this.linkSupport) {
      this.linkSupport.forEach((el) => {
        if (
          el?.cabinet_driver_id == this.currentNotification?.cabinet_driver_id
        ) {
          this.tmPark = el.max_support;
        }
      });
    }

    const href = encodeURI(`${this.currentCabinetSupportLinks.max_support}`);

    this.currentCabinetSupportLinks.max_support
      ? Browser.open({ url: href })
      : (this.statusModalDialog = true);
    this.helpDialogModal = false;
  }

  private async sendEmailPark() {
    const emailLink = this.currentCabinetSupportLinks.email_support;

    if (!emailLink || emailLink.trim() === "" || emailLink === "null") {
      this.statusModalDialog = true;
      this.statusModalText = "Партнер не указал Email для связи";
      this.helpDialogModal = false;
      return;
    }

    const date = dayjs(this.currentNotification?.date_time).format(
      "DD-MM-YYYY HH:mm:ss",
    );

    let message = `Проблема с переводом.`;
    if (this.userData?.full_name) message += ` ${this.userData.full_name}.`;
    if (this.userData?.phone_number)
      message += ` ${this.userData.phone_number}.`;
    if (this.currentNotification?.amount)
      message += ` Сумма: ${this.currentNotification.amount},`;
    if (this.currentNotification?.card_number)
      message += ` Номер карты: ${this.currentNotification.card_number},`;
    message += ` Дата: ${date},`;
    message += ` Статус: ${this.validateTransactionStatus(
      this.currentNotification?.status as ENotificationStatus,
      this.currentNotification?.adapter_status as ENotificationStatusAdapter,
      "text",
    )}`;

    if (this.currentNotification?.status_description) {
      message += `, ${this.currentNotification.status_description}`;
    }

    if (this.currentNotification?.status_payout) {
      message += `, Причина: ${this.currentNotification.status_payout}.`;
    }

    const subject = `Проблема с переводом - ${
      this.currentNotification?.card_number || ""
    }`;

    const mailtoLink = `mailto:${emailLink}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(message)}`;

    try {
      await Browser.open({ url: mailtoLink });
    } catch (error) {
      window.location.href = mailtoLink;
    }

    this.helpDialogModal = false;
  }

  private mathCommission(amount: number, commission: number) {
    const result = amount - commission;

    // Проверка в конце ноль или нет
    if (result % 1 === 0) {
      return result.toFixed(0);
    } else {
      return result.toFixed(1);
    }
  }

  created() {
    this.filtersDatetimeTo = dayjs().format("YYYY-MM-DD");

    setTimeout(() => {
      if (!this.linkSupport) {
        this.getLinkSupport?.();
      }
      this.loadData();

      if (this.$route?.name === "NotificationsPage") {
        window.addEventListener("scroll", this.handleScroll);
      }
    }, 2000);
    if (this.$PLATFORM != "web") {
      App.getInfo().then((appInfo) => {
        this.appVersion = `v${appInfo.version} ${appInfo.build}`;
      });
    }
  }

  unmounted() {
    clearInterval(this.loadNotificationInterval as number);
    window.removeEventListener("scroll", this.handleScroll);
  }
}
</script>
